import React from 'react'
import PropTypes from 'prop-types'
import StyledPaper from '../counseling-session/StyledPaper'
import Grid from '@material-ui/core/Grid'

const WarningPaper = props => (
  <StyledPaper className={props.classes && props.classes.root}>
    <Grid container alignItems="center">
      {props.icon && (
        <Grid item xs={1}>
          {props.icon}
        </Grid>
      )}

      <Grid item xs={11}>
          {props.children}
      </Grid>
    </Grid>
  </StyledPaper>
)

WarningPaper.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string
  }),
  children: PropTypes.element,
  icon: PropTypes.element
}

export default WarningPaper


// WEBPACK FOOTER //
// ./src/components/common/WarningPaper.js